/** The one place the wire's snake_case becomes the app's camelCase. */
export function toTokenPair(body) {
    return {
        accessToken: body.access_token,
        expiresAt: body.expires_at,
        refreshToken: body.refresh_token,
    };
}
/** How a pair is written to storage: one JSON value under one key. */
export function serializeTokenPair(pair) {
    return JSON.stringify(pair);
}
/**
 * Parse a stored pair, or `null` when there is nothing usable there.
 *
 * Returning `null` rather than throwing is deliberate. A corrupt or
 * hand-edited value means "signed out"; a throw here would crash the app at
 * boot, before any screen exists from which the user could sign in again.
 */
export function parseTokenPair(raw) {
    if (raw === null) {
        return null;
    }
    try {
        const value = JSON.parse(raw);
        if (typeof value.accessToken === "string" &&
            value.accessToken !== "" &&
            typeof value.refreshToken === "string" &&
            value.refreshToken !== "" &&
            typeof value.expiresAt === "number" &&
            Number.isFinite(value.expiresAt)) {
            return {
                accessToken: value.accessToken,
                expiresAt: value.expiresAt,
                refreshToken: value.refreshToken,
            };
        }
    }
    catch {
        // Not JSON. Same answer as a missing key: signed out.
    }
    return null;
}
//# sourceMappingURL=token-pair.js.map